const getProductActivityQuery = /* GraphQL */ `
  query GetProductActivity($request: ProductActivityRequestInput!) {
    productActivity(request: $request) {
      calloutColor
      productActivity {
        key
        value {
          orderCount
          orderCountDisplayText
          listCount
          calloutColor
          mobileDisplayText
          desktopDisplayText
        }
      }
    }
  }
`

export default getProductActivityQuery
